import React from "react";
import {Grid} from "@deere/fuel-react"
import { ProgressIndicator } from './ProgressIndicator'
import { QUESTION_TYPES } from "../../utils/surveyLiterals";
import { useTranslation } from "react-i18next";

export const Agreements = ({ agreements, questions, createRadio, review, answers }) => {
    const agreementQuestions = Array.isArray(questions) && questions.length > 0 && Array.isArray(agreements) ?
        questions.filter(question => agreements.some(agreement => agreement.questionAgreementId === question.id && question.idSelectionDependson===0))
        : null;
    
    const answerQuestions = Array.isArray(questions) && questions.length > 0 && Array.isArray(answers) ?
        questions.filter(question => answers.some(answer => answer.questionId === question.id && question.idSelectionDependson===0))
        : null;    
    
    let finalQuestions=null;


    Array.isArray(agreementQuestions) &&  setFinalQuestions();
    const { t } = useTranslation();
    (Array.isArray(agreementQuestions) || (Array.isArray(answerQuestions) && review)) &&  setFinalQuestions();
    
    function setFinalQuestions(){
        const tmpAgreementQuestions = review? answerQuestions: agreementQuestions;

        finalQuestions=[];
        tmpAgreementQuestions.forEach(parentQuestion => {
            const childrenQuestions= questions.filter(q => q.idQuestionDepends=== parentQuestion.id);
            if(Array.isArray(childrenQuestions)){            
               finalQuestions.push(parentQuestion);
               finalQuestions.push(...childrenQuestions);
            }
        })
    }
     
    const indicator = () => {
        if (!Array.isArray(finalQuestions))
            return <ProgressIndicator title={t('tps_lbl_waiting_country_message_title')} subtitle={t('tps_lbl_waiting_country_message_subtitle')} />
        else if (Array.isArray(finalQuestions) && finalQuestions.length === 0)
            return <ProgressIndicator title={t('tps_lbl_no_agreedment_title')} subtitle={t('tps_lbl_no_agreedment_subtitle')} />
        return <ProgressIndicator title={t('tps_lbl_waiting_country_message_title')} subtitle={t('tps_lbl_waiting_country_message_subtitle')} />    
    }

    const createType = (finalQuestion) => {
        const type = finalQuestion && finalQuestion.hasOwnProperty('type') && finalQuestion.type  ? finalQuestion.type : '';
        
        switch(type.trim().toUpperCase()){
            case QUESTION_TYPES.RADIO :return createRadio(finalQuestion);
            default : return null;
        };
 
    }

    return Array.isArray(finalQuestions) && finalQuestions.length > 0 ?
        finalQuestions.map(finalQuestion => createType(finalQuestion))
        : <Grid key={`agreementIndicator`} item md={12} >
            {indicator()}
        </Grid>
}

